import {EventEmitter, Injectable} from '@angular/core';

/**
 * A shared service to allow for navigation events to be dispatched & processed
 * within the application, without too much complexity of passing events up/down
 * the component hierarchy.
 *
 * continueClick is processed within the <app-add-on-footer> component
 * backClick is processed within the <app-add-on-header> component
 */
@Injectable({
  providedIn: 'root',
})
export class NavigationEventService {
  continueClick = new EventEmitter<void>();
  backClick = new EventEmitter<void>();
}
